export const RECEIVE_USER = "RECEIVE_USER";
export const RECEIVE_REGISTRATION_DATA = "RECEIVE_REGISTRATION_DATA";
export const RECEIVE_USER_TO_BE_TRANSFERED = "RECEIVE_USER_TO_BE_TRANSFERED";

export const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN";
export const TWO_FACTOR_REQUIRED = "TWO_FACTOR_REQUIRED";
export const EMAIL_REQUIRED = "EMAIL_REQUIRED";
export const ACTIVATION_REQUIRED = "ACTIVATION_REQUIRED";
export const IS_LOCKED = "IS_LOCKED";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_AVATAR = "UPDATE_USER_AVATAR";

export const UPDATED_USER = "UPDATED_USER";
export const UPDATED_USER_AVATAR = "UPDATED_USER_AVATAR";

export const UPDATE_USER_ATTRIBUTE = "UPDATE_USER_ATTRIBUTE";
export const UPDATE_AUTH_ATTRIBUTE = "UPDATE_AUTH_ATTRIBUTE";

export const UPDATE_THIRD_PARTY_PROVIDER = "UPDATE_THIRD_PARTY_PROVIDER";

export const RECEIVE_LOGOUT_ROUTES = "RECEIVE_LOGOUT_ROUTES";
export const RECEIVE_COUNTRIES = "RECEIVE_COUNTRIES";
export const RECEIVE_RECATCHA = "RECEIVE_RECATCHA";

export const LOADING = "LOADING";
export const LOADING_ATTRIBUTE_ADD = "LOADING_ATTRIBUTE_ADD";
export const LOADING_ATTRIBUTE_REMOVE = "LOADING_ATTRIBUTE_REMOVE";
export const LOADING_TWO_FACTOR = "LOADING_TWO_FACTOR";

//BGSLT

export const BGSLT_RECEIVE = "BGSLT_RECEIVE";
export const BGSLT_UPDATE = "BGSLT_UPDATE";
export const BGSLT_REFRESH = "BGSLT_REFRESH";
export const BGSLT_DELETE = "BGSLT_DELETE";
export const BGSLT_CREATE = "BGSLT_CREATE";
